import { Controller } from "@hotwired/stimulus"

import {stimulus} from "../init"

// Row selection + floating action bar.
// Checkboxes are `input[name="attendee_ids[]"]` (they submit through the bar's form via the
// `form` attribute). Boxes are queried live, so rows broadcast in over Turbo Streams just work.
export default class BulkSelect extends Controller {
  static targets = ["all", "bar", "count", "generateButton", "generateCount", "sendButton", "sendCount"]

  connect() {
    this.refresh()
  }

  get boxes() {
    return Array.from(this.element.querySelectorAll('input[name="attendee_ids[]"]:not(:disabled)'))
  }

  toggleAll(event) {
    this.boxes.forEach((box) => (box.checked = event.target.checked))
    this.refresh()
  }

  clear() {
    this.boxes.forEach((box) => (box.checked = false))
    this.refresh()
  }

  deferRefresh() {
    requestAnimationFrame(() => this.refresh())
  }

  refresh() {
    const boxes = this.boxes
    const selected = boxes.filter((box) => box.checked)
    const withTicket = selected.filter((box) => box.dataset.hasTicket === "true").length
    const withoutTicket = selected.length - withTicket

    boxes.forEach((box) => {
      const row = box.closest("tr")
      if (row) row.dataset.selected = String(box.checked)
    })

    if (this.hasAllTarget) {
      this.allTarget.checked = boxes.length > 0 && selected.length === boxes.length
      this.allTarget.indeterminate = selected.length > 0 && selected.length < boxes.length
    }

    this.countTarget.textContent = selected.length
    this.generateCountTarget.textContent = withoutTicket
    this.sendCountTarget.textContent = withTicket
    this.generateButtonTarget.disabled = withoutTicket === 0
    this.sendButtonTarget.disabled = withTicket === 0
    this.barTarget.dataset.visible = String(selected.length > 0)
    this.barTarget.inert = selected.length === 0
  }
}
stimulus.register('bulk-select', BulkSelect)
